import { MenuItem, TextField } from "@mui/material";
import React, { useState } from "react";

// Custom fields
// selectHeight: Number - The height of overall select component
// menuItemMargin: Number - The margin of the items in menu

const SharedSelectField = (props) => {
  const [menuOpen, setMenuOpen] = useState(true);
  const { options = [], sx, ...otherProps } = props; // Destructure props to extract options and other props
  const shortWhite = props?.variants === "shortWhite";

  return (
    <TextField
      {...otherProps}
      select
      value={props?.value ?? ""}
      variant="outlined"
      disabled={props?.disabled} // Make sure the disabled prop is passed
      sx={{
        width: "100%",
        padding: "0px !important",
        height: "36px",
        "& .MuiInputBase-input": {
          fontSize: "14px !important",
          padding: "8px 12px",
          fontSize: "auto",
          textAlign: "left",
        },
        "& .MuiInputBase-root": {
          borderRadius: "8px",
          height: "36px",
          color: !props?.value ? "#bdbdbd" : "black",
          ...(props?.disabled && {
            // Disable color change for input
            color: "#9e9e9e", // Color for disabled state
          }),
        },
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#FFF !important",

          ...(props?.disabled && {
            backgroundColor: "#E5E5E5 !important",
          }),

          height: "36px",
          "& fieldset": {
            borderRadius: "8px",
            height: props?.selectHeight,
            border: props?.isEmpty ? "1px solid #213DB5" : "1px solid #D8D8D8",
          },

          "&:hover fieldset": {
            border: "1px solid #AEAEAE",
          },
          "&.Mui-focused fieldset": {
            border: "1px solid #512ACC",
          },
          "&.Mui-error fieldset": {
            borderColor: "#F75443",
          },
        },
      }}
      SelectProps={{
        displayEmpty: true,
        onOpen: () => setMenuOpen(false),
        onClose: () => setMenuOpen(true),
        MenuProps: {
          PaperProps: {
            style: {
              background: "#fff",
              boxShadow: `2px 4px 10px 0px rgba(0, 0, 0, 0.12)`,
              borderRadius: "13px",
              display: "flex",
              width: "300px",
              borderRadius: "8px",
            },
          },
        },
      }}
    >
      {menuOpen && (
        <MenuItem value="" disabled>
          {props?.placeholder || "Please select"}
        </MenuItem>
      )}
      {options.length > 0 ? (
        options.map((item) => (
          <MenuItem
            key={item.id}
            value={item.id}
            sx={{
              minWidth: "100vw",
              height: "auto",
              padding: "8px 8px 8px 16px",
            }}
          >
            <p
              style={{
                margin: props?.menuItemMargin || "0px",
                fontSize: "14px",
              }}
            >
              {item.title || item.name}
            </p>
          </MenuItem>
        ))
      ) : (
        <MenuItem disabled>
          <div>No options available</div>
        </MenuItem>
      )}
    </TextField>
  );
};

export default SharedSelectField;
